import React from 'react';
import { Confirmation } from "../../Confirmation";
import { config } from "../../../app/config";
import TranslationService from "../../../app/services/TranslationService";
import {Button} from "../../icymat-design/Button";
import {Input} from "../../icymat-design/Input";
import {Select} from "../../icymat-design/Select";
import {Textarea} from "../../icymat-design/Textarea";


export class RecipeEdit extends React.Component {
    /**
     * @param props
     */
    constructor(props)
    {
        super(props);

        let recipe = this.props.recipe;
        recipe.removeAddress = null;

        this.state = recipe;
    };

    /**
     * @param prevProps
     * @param prevState
     */
    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.subscreen === 'edit' && prevProps.subscreen !== 'edit') {
            this.setState(this.props.recipe);
        }
    };

    /**
     * @returns {*}
     */
    mainStyle = () => {
        if (this.props.subscreen === 'edit') {
            return {display: 'block'}
        }

        return {display: 'none'}
    };

    /**
     * @param event
     */
    handleNameChange = (event) => {
        this.setState({name: event.target.value});
    };

    /**
     * @param event
     */
    handlePublicChange = (event)  => {
        this.setState({public: event.target.value === 'true'});
    };

    /**
     * @param event
     */
    handleIngredientsChange = (event) => {
        this.setState({ingredients: event.target.value});
    };

    /**
     * @param event
     */
    handleRecipeChange = (event) => {
        this.setState({recipe: event.target.value});
    };

    /**
     * @param response
     * @param address
     */
    successRemove = (response, address) => {
        this.props.reloadData();
        this.props.openSubscreen('list');
    };

    /**
     * @param response
     * @param address
     */
    errorRemove = (error, address) => {
        this.props.openSubscreen('list');
    };

    /**
     * @returns {XML}
     */
    render() {
        return (
            <div style={this.mainStyle()}>
                <Button
                    color={'main'}
                    text={TranslationService.trans(this.props.lang, 'common.save')}
                    onClick={() => this.props.saveRecipe(this.state)}
                />

                <Button
                    color={'accent'}
                    secondary={true}
                    text={TranslationService.trans(this.props.lang, 'common.cancel')}
                    onClick={() => this.props.openSubscreen('list')}
                />

                <Button
                    color={'red'}
                    secondary={true}
                    text={TranslationService.trans(this.props.lang, 'common.delete')}
                    onClick={() => this.setState({removeAddress: config.apiAddress + '/app/recipe/' + this.state.id})}
                />

                <h2 className="imd-text-20-main">{TranslationService.trans(this.props.lang, 'common.name')}</h2>
                <Input
                    color={'main'}
                    placeholder={TranslationService.trans(this.props.lang, 'common.name')}
                    value={this.state.name}
                    onChange={this.handleNameChange}
                />

                <Select
                    color={'main'}
                    value={this.state.public}
                    required={true}
                    onChange={e => {this.handlePublicChange(e)}}
                    values={{
                        'false': TranslationService.trans(this.props.lang, 'recipes.access.private'),
                        'true': TranslationService.trans(this.props.lang, 'recipes.access.public')
                    }}
                />

                <h2 className="imd-text-20-main">{TranslationService.trans(this.props.lang, 'recipes.ingredients')}</h2>
                <Textarea
                    color={'main'}
                    height={'50vh'}
                    placeholder={TranslationService.trans(this.props.lang, 'recipes.ingredients')}
                    value={this.state.ingredients}
                    onChange={this.handleIngredientsChange}
                />

                <h2 className="imd-text-20-main">{TranslationService.trans(this.props.lang, 'recipes.instructions')}</h2>
                <Textarea
                    color={'main'}
                    height={'50vh'}
                    placeholder={TranslationService.trans(this.props.lang, 'recipes.instructions')}
                    value={this.state.recipe}
                    onChange={this.handleRecipeChange}
                />

                <Confirmation
                    address={this.state.removeAddress}
                    onSuccess={this.successRemove}
                    onError={this.errorRemove}
                />
            </div>
        );
    }
}
